module.exports = __webpack_public_path__ + "static/media/DOCUMENT-SCANNER-APP.39f1dac6.png";